import styled, { css } from 'styled-components';

export const Body = styled.div`
  box-sizing: border-box;
  max-width: 850px;
  margin: 0 auto;
  background-color: #fff;
`;

export const DisbursementBody = styled.div`
  background-color: #fff;
  min-height: calc(100vh - 84px);
  padding: 20px;
`;

export const DCard = styled.div`
  margin-bottom: 2rem;
  border-radius: 8px;
  border-width: 0;
  border: 1px solid #005d1f;
  padding: 20px 16px;

  @media (min-width: 640px) {
    margin-bottom: 3rem;
    padding: 20px 16px;
  }
`;

export const RedeemTitle = styled.h1`
  font-size: 32px;
  line-height: 100%;
  font-weight: 600;
  color: #231F20;
  margin-bottom: 38px;
  text-align: center;
`;

export const RedeemSteps = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;

  @media (min-width: 640px) {
    gap: 2rem;
  }

  .redeem-step {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .step-info {
      flex: 1;
      padding-right: 1rem;

      h3 {
        margin: 0;
        margin-bottom: 12px;
        font-size: 1.125rem;
        line-height: 1.75rem;
        font-weight: 600;
        color: #231F20;

        @media (min-width: 640px) {
          font-size: 1.25rem;
          line-height: 1.75rem;
        }
      }

      .step-description {
        display: flex;
        align-items: top;
        justify-content: space-between;
        gap: 1rem;

        p {
          font-size: 16px;
          font-weight: 400;
          line-height: 100%;
          color: #231F20;
        }

        .step-icon {
          width: 32px;
          height: 32px;
          color: #005D1F;
          flex-shrink: 0;
        }
    }
`;

export const Button = styled.button`
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  padding-left: 2rem;
  padding-right: 2rem;
  border-radius: 9999px;
  width: 100%;
  font-size: 16px;
  line-height: 100%;
  font-weight: 600;
  color: #ffffff;
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 300ms;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1),
    0 4px 6px -2px rgba(0, 0, 0, 0.05);
  background-color: #008427;

  @media (min-width: 640px) {
    padding-left: 3rem;
    padding-right: 3rem;
    width: 100%;
    max-width: 326px;
    height: 43px;
    margin: 0 auto;
    font-size: 1.125rem;
    line-height: 1.75rem;
  }

  :hover {
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1),
      0 10px 10px -5px rgba(0, 0, 0, 0.04);
  }

  &:disabled {
    background-color: #9ca3af;
    cursor: not-allowed;
    box-shadow: none;
  }
`;

export const ActionWrapper = styled.div`
  text-align: center;
  padding: 0 1rem 3rem 1rem;
`;

/* Progress */
export const ProgressBar = styled.div`
  position: fixed;
  left: 0;
  top: 84px; /* height of header */
  z-index: 10;
  width: 100%;
  height: 0.5rem;
  background: #e8eef1; /* gray-200 */
`;

export const ProgressFill = styled.div`
  height: 100%;
  width: 100%;
  background: #14aa40;
  &.ten {
    width: 10%;
  }
  &.sixty-sixth {
    width: 66.6667%;
  }
  &.half {
    width: 50%;
  }
  &.third {
    width: 33.3333%;
  }
  &.quarter {
    width: 25%;
  }
  &.seventy {
    width: 70%;
  }
  &.eighth {
    width: 12.5%;
  }
  &.sixteenth {
    width: 6.25%;
  }
`;

export const BackButton = styled.button`
  margin-bottom: 1rem;
  @media (min-width: 640px) {
    margin-bottom: 1.5rem;
  }

  color: #4f4c4d;
  font-size: 16px;
  font-weight: 500;
  text-decoration: none;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
  background: transparent;
  border: none;
  padding: 0;

  &:hover {
    color: #4f4c4d;
    text-decoration: underline;
  }
`;

export const OutlineButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  color: #000000;
  padding: 0.75rem 2rem;
  cursor: pointer;
  width: 100%;
  max-width: 264px;
  min-width: 200px;
  height: 44px;
  font-weight: 600;
  font-size: 16px;
  transition: background 0.2s ease;

  background: #ffffff;
  border: 1px solid #000000;
  border-radius: 80px;

  /* Inside auto layout */
  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
  margin: 0 auto;
  transition: all 0.3s ease;

  &:hover,
  &:focus {
    background: #005d1f;
    color: #ffffff;
    svg,
    path {
      fill: #ffffff;
    }
  }

  &:disabled {
    background: #d1d5db; /* gray-300 */
    color: #6b7280; /* gray-500 */
    border: 1px solid #d1d5db; /* gray-300 */
    cursor: not-allowed;
  }
`;

export const PrimaryButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border-radius: 80px;
  font-weight: 600;
  border: 0;
  cursor: pointer;
  padding: 13px 64px;
  width: 100%;
  max-width: 326px;
  min-width: 200px;
  font-size: 16px;
  font-weight: 500;

  ${({ disabled }) =>
    disabled
      ? css`
          background: #f1f5f7;
          color: #9fa4aa;
          cursor: not-allowed;
        `
      : css`
          background: #008427;
          color: #fff;
          transition: box-shadow 0.2s ease;
          &:hover {
            background: #14aa40;
            box-shadow: none;
          }
        `};
`;

export const Label = styled.label`
  display: inline-block;
  color: #231f20;
  font-weight: 500;
  font-size: 16px;
  margin-bottom: 8px;
`;

export const TextInput = styled.input`
  width: 100%;
  margin-top: 0;
  border-radius: 8px;
  border: 1px solid ${({ $error }) => ($error ? '#D60000' : '#231F20')};
  padding: 12px 16px;
  outline: none;
  color: #231f20;

  &:focus {
    border-color: #008427;
    box-shadow: none;
  }

  &::placeholder {
    color: #6e6e6e;
  }
`;

export const Help = styled.p`
  margin: 0.25rem 0 0 0;
  color: #6e6e6e;
  font-size: 14px;
  font-weight: 500;
`;

export const FormHelp = styled.p`
  margin: 16px 0 0 0;
  color: #231f20;
  font-size: 14px;
  font-weight: 400;
`;

export const ErrorRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  margin-top: 0.5rem;
  color: #ef4444; /* red-500 */
  font-size: 14px;

  svg {
    flex-shrink: 0;
    margin-top: 2px;
  }
`;

/* Exception alerts */
export const AlertCard = styled.div`
  background: #fffbff;
  border-color: #d60000;
  margin-bottom: 1.5rem;
  padding: 20px;
  border-width: 2px;
  border-style: solid;
  border-radius: 8px;
  word-break: break-word;

  h3 {
    font-size: 18px;
    font-weight: 500;
    color: #231f20;
    margin-bottom: 16px;
    margin-top: 0;
  }

  p {
    margin: 0 0 16px 0;
    color: #231f20;
    font-size: 16px;
    font-weight: 400;
  }
`;

export const AlertRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
`;

export const DismissBtn = styled(OutlineButton)`
  margin-top: 0.75rem;
  background: transparent;
`;
